const indiaDate = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" });

export const dateInIndia = (now = new Date(), offsetDays = 0) =>
  indiaDate.format(new Date(now.getTime() + offsetDays * 24 * 60 * 60 * 1000));

export const monthStartInIndia = (now = new Date()) => `${dateInIndia(now).slice(0, 7)}-01`;
